export default __webpack_public_path__ + "static/speedup-training-1a8264c0021c795362702396ac71e5c8.svg";